<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VzH2or/images/Bec-cover.jpg?1734367810031" alt="This image is the cover for the book Bec, The Demonata"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bec, The Demonata
      </h1>
      <p class="bookDescription body article font2">
        <p><b>An orphan girl in ancient Ireland must face fearsome demons—and her own terrifying fate—as this epic YA horror series continues.</b></p><p>As demonic Fomorii ravage their land, Bec and a band of warrior companions leave their devastated refuge to answer a plea for help. An orphaned priestess-in-training, Bec hopes the journey will help her solve the mysteries of her birth. But learning the truth can be even more costly than fighting demons…</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Darren Shan
      </h2>
      
      <p class="authorDescription body article"><B>Darren Shan</B> is the bestselling author of the young adult series Cirque Du Freak, The Demonata, and the Saga of Larten Crepsley series, as well as the stand-alone book <I>The Thin Executioner</I>. His books have sold over 25 million copies worldwide. Shan divides his time between his homes in Ireland and London.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Little, Brown and Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?aeaf7c22